import * as Dialog from "@radix-ui/react-dialog";
import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";
import { t } from "ttag";

import lockIcon from "../../../../img/icons/lock-icon.svg";
import { FinancingPortalClose } from "../FinancingPortal";

import styles from "./index.module.scss";

export const FINANCING_MODAL_TITLE_ID = "financing-modal-title";

export const FinancingModalHeader = (
    props: Immutable<{
        title: string;
    }>,
): React.JSX.Element => {
    return (
        <header className={styles.root}>
            <div>
                <SVG
                    role="img"
                    aria-labelledby="credit-card-lock-icon"
                    className={styles.headerImage}
                    src={lockIcon}
                >
                    <title id="credit-card-lock-icon">
                        {t`Credit card lock icon`}
                    </title>
                </SVG>
                <Dialog.Title asChild>
                    <h1
                        id={FINANCING_MODAL_TITLE_ID}
                        className={styles.heading}
                    >
                        {props.title}
                    </h1>
                </Dialog.Title>
            </div>
            <FinancingPortalClose className={styles.button}>
                {t`Close`}
            </FinancingPortalClose>
        </header>
    );
};
